module.exports = __webpack_public_path__ + "static/media/cisco-cybersecurity.60c74a7c.png";